export default "__VITE_ASSET__42fc046b__"